import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to-cite',
  templateUrl: './how-to-cite.component.html',
  styleUrls: ['./how-to-cite.component.css']
})
export class HowToCiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
